/**
 * The URL side of a list's filters (useUrlFilterSync). The filters own only
 * their own keys: anything else in the query — the tier list's `?version=own`
 * return marker, `?action=invite` — is neither read into them nor dropped
 * when they are written back.
 */

const withoutKeys = (query, keys) => Object.fromEntries(Object.entries(query).filter(([key]) => !keys.includes(key)))

/**
 * @param {Object} currentQuery - the route query now
 * @param {Object} filterQuery - the filters that differ from their defaults, as query values
 * @param {string[]} filterKeys - every key the filters own
 * @returns {Object} the query to replace the route's with
 */
export const mergeFilterQuery = (currentQuery, filterQuery, filterKeys) => ({ ...withoutKeys(currentQuery, filterKeys), ...filterQuery })

/**
 * @param {Object} query - a parsed URL query
 * @param {string[]} filterKeys - every key the filters own
 * @returns {Object} the filter keys of `query` only
 */
export const filterQueryFromUrl = (query, filterKeys) => Object.fromEntries(Object.entries(query).filter(([key]) => filterKeys.includes(key)))
